module.exports = __webpack_public_path__ + "static/media/logo_sh-netz.6c226892.svg";